(function () {
    'use strict';

    angular.module('elogbooks.admin.asset-types', []);
})();
